import React from 'react';
import { View } from 'react-native';
import Button from 'src/components/10-atoms/button/Button';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import Column from 'src/components/10-atoms/layout/Column';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import GQLPaginatedList from 'src/lib/graphql/components/GQLPaginatedList';
import NotesListLoading from 'src/modules/admin/screens/Notes/components/NotesListLoading';
import useI18n from 'src/modules/translations/hooks/useI18n';
import styleUtils from 'src/utils/styles';
import SubjectNoteItem from './SubjectNoteItem';
import SubjectNotesEmptyList from './SubjectNotesEmptyList';
import useData from './useData';
const NotesTab = ({ subjectID, ...columnProps }) => {
    const [state, actions] = useData(subjectID);
    const [{ styles }] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    return (React.createElement(Column, { flex: true, ...columnProps },
        React.createElement(GQLPaginatedList, { LoaderComponent: React.createElement(NotesListLoading, null), ListEmptyComponent: React.createElement(SubjectNotesEmptyList, { onAddNote: actions.handleAddNote }), renderItem: ({ item }) => (React.createElement(SubjectNoteItem, { note: item, 
                // onPress={}
                onRemove: () => actions.handleRemoveNote(item.id) })), queryState: state.listQuery, queryActions: actions.listQuery, variables: state.listQueryVariables, ItemSeparatorComponent: () => React.createElement(View, { style: styles.separator }), contentContainerStyle: [
                styles.listContentContainer,
                state.listQuery.data?.totalCount ? styleUtils.floatingBtnGutter : null,
            ], containerStyle: styleUtils.flex }),
        state.listQuery.data?.totalCount !== 0 && (React.createElement(Button, { variant: 'float', onPress: actions.handleAddNote, LeftIcon: props => React.createElement(FeatherIcon, { name: "plus", ...props }) }, translate('Add Note')))));
};
const stylesGenerator = createThemedStyle(({ theme }) => ({
    listContentContainer: {
        paddingTop: theme.spacing.standard.sm,
        paddingHorizontal: theme.spacing.page,
    },
    separator: {
        height: theme.spacing.standard.sm,
    },
}));
export default NotesTab;
